"use client";

import { createContext, useContext } from "react";

type DossierScopeParams = {
  organizationKey: string;
  dossierId: string;
};

export const DossierContext = createContext<DossierScopeParams | null>(null);

export const useDossierContext = () => {
  const params = useContext(DossierContext);

  if (!params) {
    throw new Error("Attempted to use useBaseData outside of a dossier route");
  }

  return params;
};
